export default "__VITE_ASSET__C5Hwswp4__"